














import HotOfferItem from './components/hot-offer-item.vue';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import ContentLoader from './components/content-loader.vue';
import Container from '@/components/v3/container.vue';
import { to } from '@tencent/wphk-base-utils';
import { CustomException } from '@tencent/ppd-base-libs';
import { HotOffer } from '@/types/home-newest';
import { defineComponent, ref, onMounted, onUnmounted } from '@vue/composition-api';
import { getHotOfferList } from './api';
import { setImgNums, clearImgReportTimer } from './img-monitor';

export default defineComponent({
  name: 'HotOffer',
  components: {
    HotOfferItem,
    BaseComponent,
    ContentLoader,
    Container,
  },
  setup(props, { emit }) {
    // 是否展示热门优惠模块
    const showHotOfferModule = ref(true);
    // 热门优惠是否准备完毕
    const isHotOfferReady = ref(false);
    const hotOfferList = ref<HotOffer[]>([]);
    onMounted(async () => {
      const [err, hotOfferListRes] = await to(getHotOfferList());
      emit('initDone');
      if (err) {
        showHotOfferModule.value = false;
        throw new CustomException(err, 'getHotOfferListFail', '获取热门优惠列表失败');
      }
      if (hotOfferListRes.length === 0) {
        showHotOfferModule.value = false;
        throw new CustomException(err, 'hotOfferListEmpty', '热门优惠列表为空');
      }

      setImgNums(hotOfferListRes.length);

      isHotOfferReady.value = true;
      hotOfferList.value = hotOfferListRes;

    });

    onUnmounted(() => {
      clearImgReportTimer();
    });

    return {
      showHotOfferModule,
      isHotOfferReady,
      hotOfferList,
    };
  },
});
